import styled from '@emotion/styled';
import { Button, Container, SectionTitle } from '@presentation/components';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const JoinBannerWrapper = styled.div`
  margin-top: 50px;
  padding-top: 50px;
  padding-bottom: 100px;
  background: ${(props) => props.theme.color.blue.light};
  text-align: center;
`;

export const JoinBannerTitle = styled.div`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  color: ${(props) => props.theme.color.blue.default};
  ${responsiveFontSize(46, 6)};
  margin: 0 20px;
  margin-bottom: 15px;
  margin-bottom: 50px;
`;

export const TopWrapper = styled.div`
  background: ${(props) => props.theme.color.blue.lightBlue};
`;

export const TopSection = styled(Container)`
  padding-top: 100px;
  padding-bottom: 100px;
  color: ${(props) => props.theme.color.blue.default};
  position: relative;
  ${mediaQuery('tablet')} {
    padding-top: 50px;
    padding-bottom: 50px;
  }
`;

export const TopContent = styled.div`
  max-width: 850px;
  ${mediaQuery('desktop')} {
    max-width: 700px;
  }
`;

export const TopTitle = styled.h1`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 700;
  margin-bottom: 30px;
  font-size: 60px;
  line-height: 1.3;
  position: relative;
  ${mediaQuery('desktop')} {
    font-size: 46px;
  }
  ${mediaQuery('tablet')} {
    padding-top: 36px;
  }
  ${mediaQuery('phone')} {
    font-size: 26px;
  }
  ${mediaQuery('small')} {
    width: 100%;
    text-align: center;
  }
`;

export const TopSubtitle = styled.div`
  ${responsiveFontSize(30, 6)};
  font-weight: 600;
  margin-bottom: 30px;
  margin-top: 30px;
  line-height: 1.33;
  letter-spacing: 1.5px;
  ${mediaQuery('phone')} {
    font-size: 16px !important;
  }
  ${mediaQuery('small')} {
    width: 100%;
    text-align: center;
  }
`;

export const TopButtonsContainer = styled.div`
  display: flex;
  gap: 25px;

  ${mediaQuery('small', 'min')} {
    padding: 24px;
    border-radius: 56px;
    max-width: 500px;

    button {
      width: 50%;
    }
  }

  ${mediaQuery('small')} {
    flex-direction: column;
  }
`;

export const ScrollArrowWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;

  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const TopBackgroundImage = styled.div`
  font-size: 0;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 600px;
  img {
    width: 100%;
  }
  .decoration {
  }
  position: absolute;
  ${mediaQuery('desktop')} {
    max-width: 480px;
  }
  ${mediaQuery('header')} {
    display: none;
  }
`;

export const ShowMoreButton = styled(Button)`
  color: ${(props) => props.theme.color.dark.default};
  text-transform: uppercase;
`;

export const SectionSeparator = styled.img`
  bottom: 99%;
  font-size: 0;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: -1;
`;

export const SectionSeparatorBottom = styled(SectionSeparator)`
  bottom: auto;
  top: 99%;
`;

export const BreederSection = styled.div`
  background: #f7f7f7;
  margin: 100px 0;
  position: relative;
  padding-bottom: 24px;
  padding-top: 12px;
  text-align: center;
`;

export const BreedSection = styled.div`
  margin-top: 50px;
`;

export const Subtitle = styled.div`
  margin: auto;
  font-size: 18px;
  max-width: 680px;
  padding: 15px 0;
`;

// Contact section
export const ContactSection = styled.div`
  background: ${(props) => props.theme.color.blue.lightBlue};
  color: ${(props) => props.theme.color.blue.default};
  margin: 150px 0;
  padding: 30px 0;
  position: relative;
  ${mediaQuery('medium')} {
    margin: 75px 0;
    margin-bottom: 50px;
  }
`;

export const ContactContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;
  & > *:not(:last-child) {
    margin-right: 100px;
  }
`;

export const ContactImageContainer = styled.div`
  position: relative;
  width: 300px;
  height: 300px;
  ${mediaQuery('medium')} {
    display: none;
  }
`;

export const ContactImage = styled.img<{ bottom?: boolean }>`
  border-radius: 100%;
  width: 200px;
  height: 200px;
  object-fit: cover;
  position: absolute;
  ${(props) => (props.bottom ? 'top: 100px;' : 'left: 100px')}
`;

export const ContactContent = styled.div``;

export const ContactTitle = styled(SectionTitle)`
  color: ${(props) => props.theme.color.blue.default};
`;

export const ContactButtonWrapper = styled.div`
  margin-top: 15px;
  width: 100%;

  ${mediaQuery('medium')} {
    text-align: center;
  }
`;

export const CategorySection = styled.div`
  margin-top: 50px;
`;

export const CategoryLinks = styled.div`
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  margin-top: 12px;
`;

export const LinksRows = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  padding: 24px 24px 16px 24px;

  a {
    text-align: left;
    width: calc(25% - 18px);
    color: ${(props) => props.theme.color.dark.default};
    font-weight: 500;

    &:hover {
      color: ${(props) => props.theme.color.blue.default};
    }

    ${mediaQuery('tablet')} {
      width: calc(33% - 18px);
    }

    ${mediaQuery('phone')} {
      width: 100%;
    }
  }
`;

export const CategorySeeMoreWrapper = styled.div`
  padding: 6px 20px;
  text-align: right;
  border-top: 1px solid ${(props) => props.theme.color.light.shadeLighter};
`;

export const BreedInterestSection = styled.div`
  ${mediaQuery('tablet', 'min')} {
    margin-bottom: 100px;
  }
`;

export const BannerContainer = styled(Container)`
  margin-top: 50px;
`;
